module.exports = __webpack_public_path__ + "img/5_15.70204311.png";